import { useState } from "react";
import { login as loginApi } from "./AuthService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "./Login.css";

export default function Login(){

  const nav = useNavigate();
  const { login } = useAuth();
  const [username,setUsername] = useState("");
  const [password,setPassword] = useState("");
  const [error,setError] = useState("");

  const submit = async (e)=>{
    e.preventDefault();
    try{
      const data = await loginApi(username,password);

      if(!data?.token) throw new Error("Invalid login");

      login({
        userId: data.userId,
        username: data.username,
        role: data.role,
        token: data.token
      });

      nav("/today");

    }catch(err){
      setError("Invalid username or password");
    }
  };

  return (
    <div className="login-page">
      <div className="card login-card">

        <div className="login-card-header">
          <h2>Welcome Back</h2>
          <p className="login-subtitle">Login to your account</p>
        </div>

        <form onSubmit={submit} className="form-grid login-form-grid">

          <input className="input"
            placeholder="Username"
            onChange={e=>setUsername(e.target.value)}
            required
          />

          <input className="input"
            type="password"
            placeholder="Password"
            onChange={e=>setPassword(e.target.value)}
            required
          />

          {error && (
            <div className="login-error">{error}</div>
          )}

          <button className="btn btn-primary" type="submit">Login</button>
        </form>

        <div className="login-footer">
          <p
            onClick={()=>nav("/forgot-password")}
            className="login-link"
          >
            Forgot password?
          </p>

          <p className="login-muted">
            Don’t have an account?{" "}
            <span
              className="login-link"
              onClick={()=>nav("/signup")}
            >
              Sign up
            </span>
          </p>
        </div>

      </div>
    </div>
  );
}
